import React from "react";
import Layout from "../hocs/Layout";
import {connect} from "react-redux";
import Section1 from "../components/tvpc/section1";
import Tutorial from "../components/tvpc/tutorial";
import Section3 from "../components/tvpc/section3";
import Question from "../components/tvpc/question";
import Footer from "../components/navigation/Footer";

const InstallPc = ({strellatv}) => {
    return (
        <Layout>
            {strellatv &&
                (
                    <>
                        <Section1 data={strellatv}/>
                        <Tutorial data={strellatv}/>
                        <Section3/>
                        <Question/>
                        <Footer/>
                    </>
                )
            }
        </Layout>
    );
};


const mapStateToProps = state => ({
    strellatv: state.Home.strellatv,
})

export default connect(mapStateToProps, {})(InstallPc)
